import { defineMessages } from 'react-intl'

const messages = defineMessages({
  printVoucher: {
    id: 'voucher.print-voucher',
  },
  bookingCancelled: {
    id: 'global.voucher-booking-cancelled',
  },
})

export default messages
